<template>
  <Layout>
    <Gallery :images="images"></Gallery>
  </Layout>
</template>

<script>
import Gallery from "../components/Gallery.vue";
import Layout from "../Layouts/default.vue";

export default {
  components: {
    Gallery,
    Layout,
  },

  props: ["images"],
};
</script>
